import { connect } from 'react-redux'
import { Dispatch } from 'redux'

import ConfirmAcceptDeclinedProduct, { IStateProps, IDispatchProps, IOwnProps } from './ConfirmAcceptDeclinedProduct'
import { IStoreState } from '../../services/store/IStoreState'
import { closeConfirmDialog, confirmAcceptDeclinedProduct, DashboardAction } from '../../services/store/actions/dashboard/DashboardAction'
import notUndefined from '../../utils/notUndefined'

function mapStateToProps(state: IStoreState): IStateProps {
  return {
    shouldShowConfirmDialog: notUndefined(state.Dashboard.declinedProductForConfirmation),
    product: state.Dashboard.declinedProductForConfirmation,
  }
}

function mapDispatchToProps(dispatch: Dispatch<DashboardAction>): IDispatchProps {
  return {
    closeConfirmDialog: () => dispatch(closeConfirmDialog()),
    confirmAcceptDeclinedProduct: (product) => dispatch(confirmAcceptDeclinedProduct(product)),
  }
}

export default connect<IStateProps, IDispatchProps, IOwnProps, IStoreState>(
  mapStateToProps,
  mapDispatchToProps
)(ConfirmAcceptDeclinedProduct)
